import { render, staticRenderFns } from "./FolderIcon.vue?vue&type=template&id=53fe5f4e&scoped=true&lang=pug&"
import script from "./FolderIcon.vue?vue&type=script&lang=ts&"
export * from "./FolderIcon.vue?vue&type=script&lang=ts&"
import style0 from "./FolderIcon.vue?vue&type=style&index=0&id=53fe5f4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fe5f4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
